import * as React from 'react';
import * as ReactHighcharts from 'react-highcharts';
import { Table } from 'react-bootstrap';

interface IAdditionalIndicesChartProps {
  givIndexAllEnabled?: boolean;
  givAppreciationEnabled?: boolean;
  givBalancedEnabled?: boolean;
  givOtherEnabled?: boolean;
  givPreservationEnabled?: boolean;
  givSmallEnabled?: boolean;
  givMediumEnabled?: boolean;
  givLargeEnabled?: boolean;
  foundationMarkIndexEnabled?: boolean;
  cpiEnabled?: boolean;
  spEnabled?: boolean;
  sfEnabled?: boolean;
  barclayEnabled?: boolean;
  alwaysEnabled?: boolean;
}

export class AdditionalIndicesTable extends React.Component<IAdditionalIndicesChartProps, {}> {
  state = {
    indicies: [],
  };

  componentWillMount() {}

  componentDidMount() {
    this.getIndicesData();
  }

  getIndicesData() {
    const tableFilterBody = {
      action: 'getPublicIndexTable',
      request: { assetLevel: 0, name: '', monthNumber: '12', dateStart: '', dateEnd: '' },
    };
    fetch('https://kbqk6mximj.execute-api.us-east-1.amazonaws.com/Test/foundationmark-requests', {
      method: 'POST',
      body: JSON.stringify(tableFilterBody),
    })
      .then((response) => {
        return response.text();
      })
      .then((text) => {
        text = text.replace(/u0026/g, '&');
        text = text.replace(/\\/g, '');
        return JSON.parse(text);
      })
      .then((json) => {
        this.setState({ indicies: json });
      });
  }

  roundToTenths(number: number) {
    return number.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  }

  renderTableHeader() {
    return (
      <tr>
        <th>Index</th>
        <th>YTD</th>
        <th>1 Year</th>
        <th>3 Year</th>
        <th>5 Year</th>
      </tr>
    );
  }

  renderTableRow(row, index) {
    return (
      this.props[row.index] && (
        <tr key={row.index + index}>
          <td>{row.name}</td>
          <td>{this.roundToTenths(row.yearToDate)}%</td>
          <td>{this.roundToTenths(row.year)}%</td>
          <td>{this.roundToTenths(row.threeYear)}%</td>
          <td>{this.roundToTenths(row.fiveYear)}%</td>
        </tr>
      )
    );
  }

  render() {
    return (
      <Table>
        <thead>{this.renderTableHeader()}</thead>
        <tbody>
          {this.state.indicies &&
            this.state.indicies.map((indexData, index) => {
              return this.renderTableRow(indexData, index);
            })}
        </tbody>
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizations/AdditionalIndicesTable/index.tsx